"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandClient = void 0;
var axios_1 = __importDefault(require("axios"));
var BrandClient = /** @class */ (function () {
    function BrandClient(baseUrl, apiKey, getLang) {
        this.baseUrl = baseUrl;
        this.apiKey = apiKey;
        this.getLang = getLang;
        this.client = axios_1.default.create({
            baseURL: this.baseUrl,
            params: { apikey: this.apiKey }
        });
    }
    BrandClient.prototype.getBrandById = function (params) {
        var _a, _b;
        params = Object.assign({}, params, { lang: (_b = (_a = this.getLang) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : "en-us" });
        return this.client.get("/api/brands", { params: params });
    };
    BrandClient.prototype.getAllBrands = function (params) {
        var _a, _b;
        params = Object.assign({}, params, { lang: (_b = (_a = this.getLang) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : "en-us" });
        return this.client.get("/api/brands", { params: params });
    };
    return BrandClient;
}());
exports.BrandClient = BrandClient;
